
import { AbstractLayer } from './abstract-layer';
import { ImageLayerData } from 'src/app/data/configurator/layer/image-layer.data';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { CoordUtil } from 'src/app/tools/coord.utils';
import { Rectangle } from 'src/app/tools/rectangle';
import { ContextData } from 'src/app/data/context.data';

declare const fabric: any;

export class ImageLayer extends AbstractLayer {

  private _originalImg:any;
  private _cropOverlay:any;
  private _cropOverlayMasker:any;
  private _cropMasker:any;

  public cropMode:boolean;

  /**
   * Contructor
   */
  constructor(data: LayerData, stage: any) {
    super(data, stage);
  }

  /**
   * Draw
   */
  public draw(): Promise<boolean> {
    // console.log("ImageLayer.draw()");
    return new Promise((resolve, reject) => {
      fabric.Image.fromURL(this.data.imageData.base64, (img) => {


        if(this.data.special != "background"){

          this._originalImg = img;
          this._originalImg.evented = false;
          img.cloneAsImage((maskedImg)=>{

            // console.log("ImageLayer.draw() - _display ready");
            this._display = maskedImg;
            this._display.clone((cloned) => {
              this._preview = cloned;

              // console.log(this._preview);
              // console.log("ImageLayer.draw() - _preview ready");


              super._draw();

              this._display.setControlsVisibility({
                mb: false,
                ml: false,
                mr: false,
                mt: false,
              });

              resolve(true);
            });

          }, {
            width: this.data.crop.width,
            height: this.data.crop.height,
            left: this.data.crop.x,
            top: this.data.crop.y,
          })

        } else {

          this._display = img;

          this._display.clone((cloned) => {
            this._preview = cloned;

            if(Number.isNaN(this._data.width)){ // Ajout Alex
              this._data.width = this._display.width;
              this._data.height = this._display.height;
            }


            super._draw();

            this._display.setControlsVisibility({
              mb: false,
              ml: false,
              mr: false,
              mt: false,
            });

            resolve(true);
          });
        }




      });
    });
  }


  /**
   * Update data
   */
  updateData(object:any):void {
    // console.log("ImageLayer.updateData()");

    if (this._currentCanvasAngle % 360 == 0) {
      this._data.y = object.top;
      this._data.x = object.left;
    } else if (this._currentCanvasAngle % 270 == 0) {
      this._data.x = -object.top;
      this._data.y = object.left;
    } else if (this._currentCanvasAngle % 180 == 0) {
      this._data.y = -object.top;
      this._data.x = -object.left;
    } else if (this._currentCanvasAngle % 90 == 0) {
      this._data.x = object.top;
      this._data.y = -object.left;
    }


    this._data.rotation = object.angle - this._currentCanvasAngle;

    this._data.width = object.width * object.scaleX;
    this._data.height = object.height * object.scaleY;

    this._preview.left = this._data.x;
    this._preview.top = this._data.y;

    this._preview.width = object.width;
    this._preview.height = object.height;

    this._preview.scaleX = this._data.width / object.width;
    this._preview.scaleY = this._data.height / object.height;
    this._preview.angle = this._data.rotation;


    this._data.invalidate();



  }



  /**
   * Data
   */
  get data():ImageLayerData {
    return <ImageLayerData>this._data;
  }

  private _unRotatedMaskerPositionAtCropInit:any;
  private _overlayPositionAtInit:any;


  /**
   * Crop
   */
  enterCropMode(stage:any): void {
    // console.log("enterCropMode");

    this._overlayPositionAtInit = {
      x:this._originalImg.width*-.5* this._display.scaleX + this.data.normalisedCropRect.x*this._originalImg.width* this._display.scaleX,
      y:this._originalImg.height*-.5* this._display.scaleY + this.data.normalisedCropRect.y*this._originalImg.height* this._display.scaleY
    }

    // console.log(this._originalImg);

    this._cropOverlayMasker = new fabric.Rect({
      evented:false,
      width: this._display.width* this._display.scaleX,
      height: this._display.height* this._display.scaleY,
      left: this._overlayPositionAtInit.x,
      top: this._overlayPositionAtInit.y,
      inverted:true
    });

    this._cropOverlay = new fabric.Rect({
      evented:false,
      width: this._originalImg.width* this._display.scaleX ,
      height: this._originalImg.height* this._display.scaleY,
      top: this._originalImg.top,
      left: this._originalImg.left,
      angle: this._originalImg.angle,
      opacity: 0.5,
      fill: '#333333',
      clipPath:this._cropOverlayMasker
    });

    this._cropMasker = new fabric.Rect({
      width: this._display.width * this._display.scaleX,
      height: this._display.height * this._display.scaleY,
      angle: this._originalImg.angle,
      left: this._display.left,
      top: this._display.top,
      fill: 'transparent',
      cornerColor: '#36fd00',
      borderColor: '#36fd00',
      hasRotatingPoint:false,
      lockScalingX:false,
      lockScalingY:false,
      lockRotation:true,
    });


    this._cropMasker.evented = true;
    this._display.evented = false;

    this._unRotatedMaskerPositionAtCropInit = CoordUtil.rotate2D(
      {x:-this._cropMasker.left,y:-this._cropMasker.top},
      -(this._cropMasker.angle - this._currentCanvasAngle)
    );


    stage.on({
      'object:moving': this.isCropping,
      'object:scaling': this.isCropping,
      'object:resizing': this.isCropping
    });

    this._cropMasker.setControlsVisibility({
        mb: true,
        ml: true,
        mr: true,
        mt: true,
        tl: false,
        tr: false,
        br: false,
        bl: false
      });

    stage.add(this._originalImg);
    stage.add(this._cropOverlay);
    stage.add(this._cropMasker);

    this._cropMasker.setCoords();
    this._cropOverlay.setCoords();
    this._cropOverlayMasker.setCoords();

    window.setTimeout(()=>{
      this.cropMode = true;
      stage.setActiveObject(this._cropMasker);
      stage.renderAll();
    },50)

    //return;
    // this._display.evented = false;
    //this._masker.evented = true;
    // borderColor: '#36fd00',
            // cornerColor: 'green',
    // this._masker.setControlsVisibility({
    //   mb: true,
    //   ml: true,
    //   mr: true,
    //   mt: true,
    //   tl: false,
    //   tr: false,
    //   br: false,
    //   bl: false
    // });
    // console.log(this._displayImg, this._masker, this._stage);

  }

  isCropping = (e) => {
    // console.log("isCropping", this._cropMasker)
    let t: number;
    let l: number;

    let _unRotatedMaskerPositionCurrent = CoordUtil.rotate2D(
      {x:-this._cropMasker.left,y:-this._cropMasker.top},
      -(this._cropMasker.angle - this._currentCanvasAngle)
    );

    let dl: number = (this._unRotatedMaskerPositionAtCropInit.x - _unRotatedMaskerPositionCurrent.x);
    let dt: number = (this._unRotatedMaskerPositionAtCropInit.y - _unRotatedMaskerPositionCurrent.y);

    // console.log(dl, dt);


    if (this._currentCanvasAngle % 360 == 0) {
      t = this._overlayPositionAtInit.y + dt;
      l = this._overlayPositionAtInit.x + dl;
    } else if (this._currentCanvasAngle % 270 == 0) {
      t = this._overlayPositionAtInit.y +dl;
      l = this._overlayPositionAtInit.x -dt;
    } else if (this._currentCanvasAngle % 180 == 0) {
      t = this._overlayPositionAtInit.y -dt;
      l = this._overlayPositionAtInit.x -dl;
    } else if (this._currentCanvasAngle % 90 == 0) {
      t = this._overlayPositionAtInit.y -dl;
      l = this._overlayPositionAtInit.x +dt;
    }

    // console.log(this._cropOverlayMasker, this._cropMasker);

    this._cropOverlayMasker.width = this._cropMasker.width*this._cropMasker.scaleX;
    this._cropOverlayMasker.height = this._cropMasker.height*this._cropMasker.scaleY;
    this._cropOverlayMasker.left = l;
    this._cropOverlayMasker.top = t;

    this._cropOverlayMasker.dirty=true;
    this._cropOverlay.dirty=true;

    this._cropMasker.setCoords();
    this._cropOverlay.setCoords();
    this._cropOverlayMasker.setCoords();
    //this._cropOverlayMasker.canvas.renderAll();
  }


  getFinalNormalisedCrop():Rectangle {
    let _normCrop = new Rectangle(
      (this._cropOverlayMasker.left+this._cropOverlay.width*.5) / (this._originalImg.width * this._originalImg.scaleX),
      (this._cropOverlayMasker.top+this._cropOverlay.height*.5) / (this._originalImg.height * this._originalImg.scaleY),
      (this._cropMasker.width*this._cropMasker.scaleX) / (this._originalImg.width * this._originalImg.scaleX),
      (this._cropMasker.height*this._cropMasker.scaleY) / (this._originalImg.height * this._originalImg.scaleY)
    );

    if((_normCrop.x>1) || (_normCrop.y>1) || (_normCrop.x+_normCrop.width<0) || (_normCrop.y+_normCrop.height<0)){
      return null;
    }

    if(_normCrop.x<0){
      _normCrop.width += _normCrop.x;
      _normCrop.x = 0;
    }

    if(_normCrop.y<0){
      _normCrop.height += _normCrop.y;
      _normCrop.y = 0;
    }

    if(_normCrop.x+_normCrop.width<0){
      _normCrop.width = 1 - _normCrop.x;
    }

    if(_normCrop.y+_normCrop.height<0){
      _normCrop.height = 1 - _normCrop.y;
    }

    // console.log(_normCrop);
    return _normCrop;
  }

  /**
   * Crop
   */
  exitCropMode(stage, apply:boolean): void {

    stage.off({
      'object:moving': this.isCropping,
      'object:scaling': this.isCropping,
      'object:resizing': this.isCropping
    });



    this._cropMasker.evented = false;
    this._originalImg.evented = false;
    this._cropOverlay.evented = false;
    stage.remove(this._originalImg);
    stage.remove(this._cropOverlay);
    stage.remove(this._cropMasker);
    this.cropMode = false;



    if(!apply) return;

    let _finalNormalisedCrop = this.getFinalNormalisedCrop();

    this._originalImg.cloneAsImage((maskedImg)=>{


     // stage.remove(this._display);
      this.data.crop = {
        x:_finalNormalisedCrop.x*this.data.imageData.width,
        y:_finalNormalisedCrop.y*this.data.imageData.height,
        width:_finalNormalisedCrop.width*this.data.imageData.width,
        height:_finalNormalisedCrop.height*this.data.imageData.height,
      }

      this._display.setElement(maskedImg.getElement());
      this._display.clone((cloned) => {
        this._preview.setElement(cloned.getElement());
        this._display.evented = true;

        this._display.left = this._cropMasker.left;
        this._display.top = this._cropMasker.top;

        // console.log(this._display, this._cropMasker);
        this._display.setCoords();
        this.updateData(this._display);
        this.updateView();

        stage.setActiveObject(this._display);
        stage.renderAll();
      });



    }, {
      width: _finalNormalisedCrop.width*this.data.imageData.width,
      height: _finalNormalisedCrop.height*this.data.imageData.height,
      left: _finalNormalisedCrop.x*this.data.imageData.width,
      top: _finalNormalisedCrop.y*this.data.imageData.height,
      withoutTransform:true
    });
  }

  /**
   * Update view
   */
  updateView(): void {
    // console.log("ImageLayer.updateView()");

    if ((<ImageLayerData>this._data).color) {
      this._display.filters = [new fabric.Image.filters.BlendColor({
        color: (<ImageLayerData>this._data).color,
        mode: 'hardlight'
      })];
      this._display.applyFilters();

      this._preview.filters = [new fabric.Image.filters.BlendColor({
        color: (<ImageLayerData>this._data).color,
        mode: 'hardlight'
      })];
      this._preview.applyFilters();

    }

    this._display.angle = this._currentCanvasAngle + this._data.rotation;
    this._preview.angle = this._data.rotation;

    if (!isNaN(this._data.width) && isNaN(this._data.height)) {
      this._display.scaleX = this._data.width / this._display.width;
      this._display.scaleY = this._display.scaleX;
      this._data.height = this._display.height * this._display.scaleX;
    } else if (isNaN(this._data.width) && !isNaN(this._data.height)) {
      this._display.scaleY = this._data.height / this._display.height;
      this._display.scaleX = this._display.scaleY;
      this._data.width = this._display.width * this._display.scaleY;
    } else if (isNaN(this._data.width) && isNaN(this._data.height)) {
      this._display.scaleY = ContextData.CONVERT_72_TO_DPI;
      this._display.scaleX = ContextData.CONVERT_72_TO_DPI;
    }

    if (!isNaN(this._data.width)) {
      this._display.scaleX = this._data.width / this._display.width;
    } else {
      this._data.width = this._display.width * this._display.scaleX;
    }

    if (!isNaN(this._data.height)) {
      this._display.scaleY = this._data.height / this._display.height;
    } else {
      this._data.height = this._display.height * this._display.scaleY;
    }

    if(this._originalImg){
      // this._originalImg.width = this.data.imageData.width;
      // this._originalImg.height = this.data.imageData.height;
      this._originalImg.scaleX = this._display.scaleX;
      this._originalImg.scaleY = this._display.scaleY;
    }

    this._preview.scaleX = this._display.scaleX;
    this._preview.scaleY = this._display.scaleY;

    this.updatePosition();
  }

  protected updatePosition():void {
    // console.log("ImageLayer.updatePosition()");

    super.updatePosition();

    let _cropImageRect = this.data.beforeCropImageRect;
    let t: number;
    let l: number;
    if (this._currentCanvasAngle % 360 == 0) {
      t = _cropImageRect.y;
      l = _cropImageRect.x;
    } else if (this._currentCanvasAngle % 270 == 0) {
      t = -_cropImageRect.x;
      l = _cropImageRect.y;
    } else if (this._currentCanvasAngle % 180 == 0) {
      t = -_cropImageRect.y;
      l = -_cropImageRect.x;
    } else if (this._currentCanvasAngle % 90 == 0) {
      t = _cropImageRect.x;
      l = -_cropImageRect.y;
    }

    if(this._originalImg){
      // console.log(_cropImageRect);
      this._originalImg.set({
        left:l,
        top:t,
        angle : this.display.angle
      });
      this._originalImg.setCoords();
    }
  }

  /**
   * Cleanup
   */
  public cleanup(): void {

  }
}
